import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query ssoUsers(
      $username: String
      $lastName: String
      $email: String
      $limit: Int
      $offset: Int
      $showAll: Boolean
    ) {
      ssoUsers(
        username: $username
        lastName: $lastName
        email: $email
        limit: $limit
        offset: $offset
        showAll: $showAll
      ) {
        id
        username
        firstName
        lastName
        email
        isActive
        dateJoined
        lastLogin
        roles {
          id
          name
          data
        }
        count
        hasNext
        hasPrevious
      }
    }
  `,
  variables: ({
    username,
    lastName,
    email,
    showAll,
    page = 1,
    itemsPerPage = 10,
  }) => {
    return {
      username,
      lastName,
      email,
      showAll,
      limit: itemsPerPage,
      offset: itemsPerPage * (page - 1),
    };
  },
  config: {
    // errorPolicy: "none",
    fetchPolicy: "network-only",
  },
  propTypes: {
    skip: PropTypes.bool,
  },
  dataKey: "ssoUsers",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/users.js